import { State } from "../types/store";

export const selectRulesForList = (state: State) => {
    return state.logic.data;
};
